"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QwilrPayPrompt = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_react_1 = require("mobx-react");
var styles = __importStar(require("./QwilrPayPrompt.css"));
var inversify_react_1 = require("inversify-react");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var PromptTypes_1 = require("@CommonFrontend/Prompt/PromptTypes");
exports.QwilrPayPrompt = (0, mobx_react_1.observer)(function (_a) {
    var children = _a.children;
    var blockCreator = (0, inversify_react_1.useInjection)("blockCreator");
    var project = (0, inversify_react_1.useInjection)("project");
    var inlinePromptsHistoryStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore.inlinePromptsHistoryStore;
    var promptDismissed = inlinePromptsHistoryStore.hasDismissed(PromptTypes_1.PromptId.QwilrPayQuoteBlockTooltip);
    var _b = __read((0, react_1.useState)(!promptDismissed), 2), showPrompt = _b[0], setShowPrompt = _b[1];
    var dismissPrompt = function () {
        setShowPrompt(false);
        inlinePromptsHistoryStore.dismissedPrompt(PromptTypes_1.PromptId.QwilrPayQuoteBlockTooltip);
    };
    var addAcceptBlock = function () {
        dismissPrompt();
        return blockCreator.createAndInsert(BlockTypes_1.BlockType.Accept, project.blocks.length, BlockTypes_1.BlockPreset.Payments);
    };
    (0, react_1.useEffect)(function () {
        if (project.hasAcceptEnabled) {
            dismissPrompt();
        }
    }, [project.hasAcceptEnabled]);
    return (react_1.default.createElement(kaleidoscope_1.Popover, { button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ className: styles.popOverButton }, buttonProps, { type: kaleidoscope_1.ButtonType.Tertiary }), children)); }, isOpen: showPrompt, position: kaleidoscope_1.PopoverPosition.Right, offset: 4, caret: true, padding: "none", className: styles.promptWrapper, autoStack: false },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.qpayPrompt, padding: "s" },
            react_1.default.createElement(kaleidoscope_1.Stack, { align: "end", justify: "end" },
                react_1.default.createElement(icons_1.Close, { className: styles.closeButton, onClick: dismissPrompt })),
            react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", justify: "center", gap: "xxs", paddingLeft: "s", paddingRight: "s", paddingBottom: "m" },
                react_1.default.createElement(kaleidoscope_1.Heading, { className: styles.heading, strong: true, level: "3" }, "Get paid instantly"),
                react_1.default.createElement(kaleidoscope_1.Text, { className: styles.description, size: "m" }, "Start collecting payments."),
                react_1.default.createElement(kaleidoscope_1.Button, { className: styles.button, onClick: function () { return addAcceptBlock(); } }, "Activate Payments")))));
});
